import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { SpinnerButton } from 'components';
import { authenticationService } from 'interactive-solutions/authentication';
import { Link } from 'react-router';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import LoginBottomElement from './tabs/login-bottom-element';

export class LoginView extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    switchView: PropTypes.func.isRequired,
    errorMessage: PropTypes.string
  };

  constructor (props) {
    super(props);

    let defaultEmail = '';
    let defaultPassword = '';

    if (process.env.DEV_LOGIN_EMAIL && process.env.DEV_LOGIN_PASSWORD) {
      defaultEmail = process.env.DEV_LOGIN_EMAIL;
      defaultPassword = process.env.DEV_LOGIN_PASSWORD;
    }

    this.state = {
      email: defaultEmail,
      password: defaultPassword,

      loading: false,
      errorMessage: false,
      successMessage: false,
      remember: false
    };

    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.toggleRemember = this.toggleRemember.bind(this);
  }

  handleChangeEmail (event) {
    this.setState({ email: event.target.value });
  }

  handleChangePassword (event) {
    this.setState({ password: event.target.value });
  }

  removeSpaces (str) {
    return str.replace(/\s/g, '');
  }

  submitForm (e) {
    e.preventDefault();

    this.setState({
      loading: true,
      errorMessage: false,
      successMessage: false
    });

    authenticationService
      .sendMagicLoginLink(this.removeSpaces(this.state.email), this.state.password)
      .then((response) => {
        if (response.status) {
          if (response.status === 201) {
            this.setState({
              loading: false,
              successMessage: proxyCounterpart('LOGIN_LINK_SENT_CHECK_YOUR_EMAIL')
            });
            return;
          }
          let langCode = 'GENERAL_ERROR';
          if (response.status === 403) {
            langCode = 'LOGIN_403_ERROR';
          }
          if (response.status === 422) {
            langCode = 'LOGIN_ERROR';
          }
          this.setState({
            loading: false,
            errorMessage: proxyCounterpart(langCode)
          });
          return;
        }
      })
      .catch((error) => {
        let langCode = 'GENERAL_ERROR';

        if (error.status === 400) {
          langCode = 'LOGIN_ERROR';
        }

        if (error.status === 403) {
          langCode = 'LOGIN_403_ERROR';
        }

        this.setState({
          loading: false,
          errorMessage: proxyCounterpart(langCode)
        });
      });
  }

  toggleRemember () {
    this.setState({
      remember: !this.state.remember
    });
  }

  renderForm () {
    if (!this.state.successMessage) {
      return (
        <form action='' method='POST' id='login-form'>
          <div className='login-input-container'>
            <input
              type='text'
              name='email'
              className='no-margin'
              placeholder={proxyCounterpart('EMAIL')}
              value={this.state.email}
              onChange={this.handleChangeEmail}
              autoCorrect='off'
              autoComplete='off'
            />

            <input
              type='password'
              name='password'
              autoComplete='off'
              className='bottom-margin-only'
              placeholder={proxyCounterpart('PASSWORD')}
              value={this.state.password}
              onChange={this.handleChangePassword}
            />
          </div>

          <p className='text-error'> {this.state.errorMessage} </p>
          <div className='login-row-container'>
            <div className="login-row-child">
              <Link to='forgot-password'><Translate content='FORGOT_PASSWORD' />?</Link>
            </div>
          </div>
          <SpinnerButton
            id="login-button"
            text={proxyCounterpart('LOGIN')}
            loading={this.state.loading}
            classes='btn cover'
            callback={this.submitForm}
          />
          <LoginBottomElement
            isLogin
            handleClick={this.props.switchView}
          />
        </form>
      );
    }
  }

  renderSuccessMessage () {
    if (this.state.successMessage) {
      return (
        <div className='success-message-login-link-sent pre-wrap'>
          {this.state.successMessage}
        </div>
      );
    }
  }

  render () {
    return (
      <div>
        {this.renderForm()}
        {this.renderSuccessMessage()}
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    failedAuthentication: state.auth === null
  };
}

export default connect(mapStateToProps)(LoginView);



/** WEBPACK FOOTER **
 ** ./src/views/login-view/login-view.js
 **/